import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { useVoiceRecognition } from 'hooks'
import { setData, setDrawer } from 'slices/drawer'
import {
  FAQ_INPUT_SEARCH_MAX_CHARACTERS,
  FAQ_INPUT_SEARCH_MIN_CHARACTERS,
  FAQ_REDIRECT_DESTINATION,
} from 'app-constants'
import { faqService } from 'services'
import './style.scss'

export function FaqInputSearch({ onError, onLoading = () => {}, onLoadingEnd = () => {} }) {
  const [inputValue, setInputValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const { getFunctionCallingResponse } = faqService()
  const { handleStart, handleStop, isRunning, voiceText, isSupported } = useVoiceRecognition(
    FAQ_INPUT_SEARCH_MAX_CHARACTERS
  )

  useEffect(() => {
    setInputValue(voiceText)
  }, [voiceText])

  function handleMicrofoneClick() {
    if (isRunning) handleStop()
    else handleStart()
  }

  function handleFunctionCallingResponse(name) {
    const redirectDestination = FAQ_REDIRECT_DESTINATION[name]

    if (redirectDestination) {
      dispatch(setData({ search: inputValue }))
      dispatch(setDrawer(redirectDestination))
    }
  }

  function handleLoading(status) {
    setIsLoading(status)

    if (status) onLoading()
    else onLoadingEnd()
  }

  async function handleSubmitClick() {
    if (getIsSubmitButtonDisabled()) return

    try {
      handleLoading(true)
      const { data } = await getFunctionCallingResponse(inputValue)

      handleFunctionCallingResponse(data.name)
    } catch (error) {
      console.error(error)

      if (onError) onError()
    } finally {
      handleLoading(false)
    }
  }

  function handleEnterKeyClick(event) {
    const { key } = event

    if (key === 'Enter') {
      event.preventDefault()
      handleSubmitClick()
    }
  }

  function handleInputChange(event) {
    const { value } = event.target
    const slicedValue = value.substring(0, FAQ_INPUT_SEARCH_MAX_CHARACTERS)
    setInputValue(slicedValue)
  }

  function getIsSubmitButtonDisabled() {
    const invalidLength =
      inputValue.length < FAQ_INPUT_SEARCH_MIN_CHARACTERS ||
      inputValue.length > FAQ_INPUT_SEARCH_MAX_CHARACTERS
    return invalidLength || isRunning || isLoading
  }

  function renderMicroPhoneButton() {
    if (!isSupported) return null

    return (
      <button type='button' onClick={handleMicrofoneClick} className='microfone-button'>
        <STATICS.MICROPHONE />
      </button>
    )
  }

  return (
    <div className='container-faq-input-search'>
      <label className='container-input' htmlFor='faq-input'>
        <input
          id='faq-input'
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleEnterKeyClick}
          className='faq-input-search'
          placeholder='Digite ou fale sua dúvida'
          maxLength={FAQ_INPUT_SEARCH_MAX_CHARACTERS}
        />
        <div className='container-buttons'>
          {renderMicroPhoneButton()}
          <button
            disabled={getIsSubmitButtonDisabled()}
            type='submit'
            onClick={handleSubmitClick}
            className='submit-button'
          >
            <STATICS.FAQ_SUBMIT />
          </button>
        </div>
      </label>

      <span className='faq-input-length'>
        {inputValue.length}/{FAQ_INPUT_SEARCH_MAX_CHARACTERS}
      </span>
    </div>
  )
}
